import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { cn } from '@/lib/utils';

function CardCopy({ festival }) {
  return (
    <>
      <h3 className="m-0 text-lg font-bold leading-snug tracking-tight text-white drop-shadow-sm">
        {festival ? festival.name : 'Add New'}
      </h3>
      {festival && (
        <>
          <p className="mt-2 text-sm font-normal leading-snug text-white/95 [&_svg]:mr-1.5 [&_svg]:inline [&_svg]:text-[0.85em] [&_svg]:opacity-95">
            <FontAwesomeIcon icon={['fas', 'location-dot']} />{' '}
            {festival.location.locationName}
          </p>
          <p className="mt-1 text-sm font-normal text-white/95 [&_svg]:mr-1.5 [&_svg]:inline [&_svg]:text-[0.85em] [&_svg]:opacity-95">
            <FontAwesomeIcon icon={['far', 'calendar-days']} />{' '}
            {moment(festival.startDate.startTime).format('M-D-YYYY')}
          </p>
        </>
      )}
    </>
  );
}

export const FestivalCard = ({ festival, onClick, ...props }) => {
  const isAddNew = !festival;
  const hasPhoto = Boolean(festival?.photoURL);

  const cardStyle =
    !isAddNew && hasPhoto
      ? { backgroundImage: `url(${festival.photoURL})` }
      : {};

  const outerClass = cn(
    'relative min-h-[200px] w-[min(100%,264px)] shrink-0 overflow-hidden rounded-[10px] bg-cover bg-center shadow-md transition-[box-shadow,transform] duration-300',
    isAddNew && 'bg-[#8a8a8a]',
    !isAddNew && !hasPhoto && 'bg-neutral-600',
    !isAddNew && 'cursor-pointer hover:scale-[1.02] hover:shadow-lg',
    isAddNew && 'cursor-pointer hover:brightness-110',
  );

  const interactiveClass =
    'relative z-10 flex min-h-[200px] flex-col items-start p-4 text-left text-white';

  const inner = isAddNew ? (
    <div
      className={interactiveClass}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick?.(e);
        }
      }}
    >
      <CardCopy festival={festival} />
    </div>
  ) : (
    <>
      {/* Top-heavy gradient so photos stay vivid toward the bottom (Photo #2) */}
      <div
        className="pointer-events-none absolute inset-0 rounded-[10px] bg-gradient-to-b from-black/75 via-black/45 to-transparent"
        aria-hidden
      />
      {festival && !onClick ? (
        <Link
          to={`/festival/${festival.festivalId}`}
          className={interactiveClass}
        >
          <CardCopy festival={festival} />
        </Link>
      ) : (
        <div
          className={interactiveClass}
          role="button"
          tabIndex={0}
          onClick={onClick}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onClick?.(e);
            }
          }}
        >
          <CardCopy festival={festival} />
        </div>
      )}
    </>
  );

  return (
    <div className={outerClass} style={cardStyle} {...props}>
      {inner}
    </div>
  );
};
